import { Selector } from '../../lib/generated/zeus';

export const sendEmailResponseSelector = Selector('SendEmailResponse')({
  status: true,
  errorMessage: true,
});
